<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div v-if="loading || articleList.length > 0">
        <div
          class="editorial-position"
          v-for="item in articleList"
          :key="item.positionTitle"
        >
          <h1 class="position-title">
            <span class="position-title-line"></span>
            <span>{{ item.positionTitle }}</span>
          </h1>
          <div
            class="editorial-item"
            v-for="i in item.editorialList"
            :key="i.id"
            @click="toBJZX(i.userId)"
          >
            <div class="item-top">
              <img
                class="item-photo"
                :src="
                  i.headImg
                    ? $global.imgUrl + i.headImg
                    : require('@/assets/img/mobile-img/default-photo.png')
                "
                alt=""
              />
              <div>
                <div>
                  <span class="item-name">{{ i.userName }}</span>
                  <template  v-for="title in i.title">
                    <span  :key="title.levelTwo" v-if="title.levelTwo" class="item-position">{{ title.levelTwo }}</span>
                  </template>
                </div>
                <p class="item-profession">
                  <span class="item-profession-orgName">{{ i.orgName }}</span>
                  <span class="item-profession-position">{{ i.position }}</span>
                </p>
              </div>
            </div>
            <p class="item-introduction">{{ i.profile }}</p>
          </div>
        </div>
      </div>
      <noneList v-else />
    </van-list>
  </div>
</template>

<script>
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  components: { noneList },
  data() {
    return {
      articleList: [], // 文章List
      params: {
        pageNo: 0,
        pageSize: 20,
        periodicalId: this.$route.query.id,
      },
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const res = await this.$apis.hundredServe.getBkEditorialList(this.params);
      if (res.resultCode === "200") {
        res.data.list.forEach((item) => {
          if (
            this.articleList.some(
              (i) => i.positionTitle === item.periodicalGuestTypeNm
            )
          ) {
            this.articleList[this.articleList.length - 1].editorialList.push({
              ...item,
              title: JSON.parse(item.title),
            });
          } else {
            this.articleList.push({
              positionTitle: item.periodicalGuestTypeNm,
              editorialList: [{ ...item, title: JSON.parse(item.title) }],
            });
          }
        });
        this.finished = res.data.list.length < 20;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    toBJZX(id) {
      if(!id) return
      let out = this.$route.query.out;
      this.$router.push({
        path: "appusesbaijia",
        query: { item: 0, id, out },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editorial-position {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  .position-title {
    font-size: 15px;
    color: #333333;
    .position-title-line {
      display: inline-block;
      margin-right: 5px;
      width: 2px;
      height: 15px;
      background-color: #4a79f1;
      border-radius: 1px;
      vertical-align: middle;
    }
  }
  .editorial-item {
    margin-top: 12px;
    .item-top {
      display: flex;
      margin-bottom: 10px;
      .item-photo {
        margin-right: 10px;
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      .item-name {
        margin-right: 10px;
        font-size: 15px;
        color: #333333;
        font-weight: 700;
      }
      .item-position {
        margin-right: 5px;
        margin-bottom: 4px;
        display: inline-block;
        padding: 2px 9px;
        background-color: rgba(74, 121, 241, 0.1);
        font-size: 12px;
        color: #4a79f1;
      }
      .item-profession {
        display: flex;
        align-items: center;
        margin-top: 5px;
        width: 250px;
        font-size: 13px;
        color: #999999;
        .item-profession-orgName {
          margin-right: 5px;
          display: inline-block;
          flex: none;
          max-width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item-profession-position {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .item-introduction {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      font-size: 14px;
      color: #333333;
      line-height: 23px;
    }
  }
}
</style>
